import { AuditStationPage } from '@app/modules/audit/components/AuditStationPage';
import { StationReportsPage } from './StationReportsPage';

/**
 * Wraps the station reports page in the audit station layout for station-scoped audit routes.
 */
export function AuditReportsPageAdapter() {
  return (
    <AuditStationPage>
      <StationReportsPage />
    </AuditStationPage>
  );
}
